@use 'ui/styles/core-tokens' as core;

.popupContainer {
  &Text {
    padding-bottom: 50px;
    text-align: center;
  }
}

.processingPopup {
  &Buttons {
    display: flex;
    justify-content: space-evenly;
    width: 100%;

    &Item {
      width: 160px;
    }
  }
}
